import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { ModalShell } from '@quizzach/components';
import { richTextEmphasis } from '@quizzach/play-styles';

/* the modal shows the same author-written HTML as the play stage, so the
   u/b emphasis has to match */
const ExplanationBody = styled.div`
	font-size: 18px;
	line-height: 1.55;
	${richTextEmphasis}
`;

export const AnswerExplanationModal = ({
	show,
	closeModal,
	explanation,
}: {
	show: boolean;
	closeModal: () => void;
	explanation: string;
}) => {
	const { t } = useTranslation();

	return (
		<ModalShell
			show={show}
			onClose={closeModal}
			size='lg'
			label={t('modal.answerExplanation.title')}
		>
			<ExplanationBody
				dangerouslySetInnerHTML={{
					__html: explanation || '',
				}}
			/>
		</ModalShell>
	);
};
